export default __webpack_public_path__ + "static/media/front-end.0b491dbc.svg";